

export default class TradingViewChartFeeder {
  _subscribers: any;
  _service: any;
  _lastChartBar: any;
  constructor(service: any) {
    this._subscribers = {};
    this._service = service;
    this._lastChartBar = {time: 0};
  }

  onReady(callback: any) {
    var configurationData = {
      supports_search: false,
      supports_group_request: true,
      supported_resolutions: ['1', '5', '15', '30', '60', '1D', '1W', '1M'],
      supports_marks: false,
      supports_timescale_marks: false,
      supports_time: false,
    };

    setTimeout(function () {
      callback(configurationData);
    }, 0);
  }

  searchSymbols(userInput: any, exchange: any, symbolType: any, onResultReadyCallback: any) {}

  resolveSymbol(symbolName: any, onSymbolResolvedCallback: any, onResolveErrorCallback: any) {
    if (symbolName == 'null') {
      setTimeout(function () {
        onSymbolResolvedCallback({
          name: ' ',
          description: ' ',
          full_name: ' ',
          listed_exchange: ' ',
          exchange: ' ',
          session: '24x7',
          type: 'stock',
          timezone: 'UTC',
          base_name: ' ',
          ticker: 'null',
          minmov: 1,
          minmove2: 0,
          fractional: false,
          pricescale: 1,
          force_session_rebuild: false,
          intraday_multipliers: ['1'],
          has_intraday: true,
          has_daily: false,
          has_weekly_and_monthly: false,
          has_empty_bars: false,
          has_no_volume: false,
          volume_precision: 0,
        });
      }, 0);
    } else if (!symbolName.startsWith('sec.')) {
      setTimeout(function () {
        onResolveErrorCallback();
      }, 0);
    } else {
      this._service.symbolInfo(symbolName, onSymbolResolvedCallback, onResolveErrorCallback);
    }
  }

  getBars(symbolInfo: any, resolution: any, from: any, onHistoryCallback: any, onErrorCallback: any, firstDataRequest: any) {
    var self = this;

    if (symbolInfo.ticker == 'null') {
      setTimeout(function () {
        onHistoryCallback([], {noData: true});
      });
    } else {
      // TradingView günlük periyodu "1D" iletiyor; "D" gelirse de servis kabul etmiyor
      // (desteklenenler: 1D, 1, 5, 15, 30, 60), bu yüzden "1D"ye çeviriyoruz.
      const historyResolution = resolution === 'D' ? '1D' : resolution;
      // Servis günlük seride varsayılan olarak AdjExDiv (temettü düzeltmeli) döner;
      // dövizlerde temettü olmadığı için bu seri boş geliyor, Adj istenmeli.
      const fieldType = symbolInfo.type === 'currency' ? 'Adj' : undefined;

      this._service.history(
        {Symbol: symbolInfo.ticker, StartDate: from["from"], EndDate: from["to"], Resolution: historyResolution, FieldType: fieldType},
        (bars: any, meta: any) => {
          onHistoryCallback(bars, meta);
        },
        onErrorCallback
      );
    }
  }

  subscribeBars(symbolInfo: any, resolution: any, onRealtimeCallback: any, subscriberUID: any, onResetCacheNeededCallback: any) {
    if (symbolInfo.ticker == 'null') return;

    var prevDailyVolume: any = undefined;
    var tickerModel: any = {};
    var self = this;

    this._subscribers[subscriberUID] = this._service.subscribe({objectIds: [symbolInfo.ticker]}, (msg: any) => {
      var ticker = msg['@'];

      if (ticker != symbolInfo.ticker) return;

      for (var field in msg) {
        if (field != '@') tickerModel[field] = msg[field];
      }

      var time = tickerModel['date'] * 1000;
      var dailyOpen = tickerModel['dailyOpen'];
      var dailyHigh = tickerModel['dailyHigh'];
      var dailyLow = tickerModel['dailyLow'];

      if (prevDailyVolume == undefined) prevDailyVolume = tickerModel['dailyVolume'];

      var price = tickerModel['lastPrice'];
      var dailyVolume = tickerModel['dailyVolume'];
      var volume = dailyVolume - prevDailyVolume;

      if (volume < 0) volume = 0;

      if (resolution == 'D' || resolution == '1D') {
        onRealtimeCallback({time: time, open: dailyOpen, high: dailyHigh, low: dailyLow, close: price, volume: dailyVolume});
      } else if (resolution == '1') {
        time = Math.floor(time / 60000) * 60000;

        if (self._lastChartBar.time != time) {
          self._lastChartBar.time = time;
          self._lastChartBar.open = price;
          self._lastChartBar.high = price;
          self._lastChartBar.low = price;
          self._lastChartBar.close = price;
          self._lastChartBar.volume = volume;
        } else {
          self._lastChartBar.high = Math.max(self._lastChartBar.high, price);
          self._lastChartBar.low = Math.min(self._lastChartBar.low, price);
          self._lastChartBar.close = price;
          self._lastChartBar.volume += volume;
        }

        onRealtimeCallback({
          time: self._lastChartBar.time,
          open: self._lastChartBar.open,
          high: self._lastChartBar.high,
          low: self._lastChartBar.low,
          close: self._lastChartBar.close,
          volume: self._lastChartBar.volume,
        });
      }

      prevDailyVolume = tickerModel['dailyVolume'];
    });
    // this._subscribers[subscriberUID] = this._service.subscribe(symbolInfo.ticker, (msg) => {});
  }

  unsubscribeBars(subscriberUID: any) {
    var uns = this._subscribers[subscriberUID];

    if (uns) uns.Dispose();

    this._subscribers[subscriberUID] = undefined;
  }

  remove_calculateHistoryDepth(resolution: any, resolutionBack: any, intervalBack: any) {}

  getMarks(symbolInfo: any, from: any, to: any, onDataCallback: any, resolution: any) {}

  getTimescaleMarks(symbolInfo: any, from: any, to: any, onDataCallback: any, resolution: any) {}

  getServerTime(callback: any) {
    return Math.round(new Date().getTime() / 1000);
  }
}
